import React from 'react';
import { percentFormat } from '../../Utils/NumberFormatting';
import { Graph, Circle, Name } from './styles';

export default function City(props) {
	return <Graph href={`${props.linkToMunicipal}#/obec/${props.id}`}>
		<Circle style={{ opacity: props.meta.count / 100 }} />
		<Name>
			{props.name}:&nbsp;
			<span>{percentFormat(props.meta.count, 0)}</span>
		</Name>
	</Graph>
}
